module.exports = __webpack_public_path__ + "static/logo-grad-d9b889cc93ea66762f503476ac9b2f49.svg";